import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { FormsModule } from "@angular/forms";
import { File } from "@awesome-cordova-plugins/file/ngx";
import { CoreModule } from "./core/core.module";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { IonicModule } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";
import { provideTranslateService, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

@NgModule({
  imports: [
    IonicModule.forRoot(),
    BrowserModule,
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    CoreModule,
    FormsModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    TranslatePipe,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    InAppBrowser,
    SocialSharing,
    File,
    ScreenOrientation,
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    provideTranslateService({
      lang: "es",
      fallbackLang: "es",
      loader: provideTranslateHttpLoader({
        prefix: "assets/i18n/",
        suffix: ".json",
      }),
    }),
  ],
  bootstrap: [AppComponent],
  declarations: [AppComponent],
})
export class AppModule {}
